var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chips-list"},_vm._l((_vm.categoriesItems),function(item){return _c('ProgressChipsListItem',{key:item.id,attrs:{"item":item,"active":item.id === _vm.active},on:{"update":(e) => _vm.$emit('update',e)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }